export default "__VITE_ASSET__341c4d0b__"